module.exports = __webpack_public_path__ + "img/BAWS_Staff2_2_6.c1c4bfc5.png";